module.exports = __webpack_public_path__ + "static/media/about1.ffa11166.jpg";